import styles from "@/styles/layout/Footer.module.css";
import Image from "next/image";
import { BRANDING, BrandingConfig } from "@/config/brand";
import { FacebookOutlined, InstagramOutlined, LinkedinOutlined, YoutubeOutlined } from '@ant-design/icons';

interface FooterProps {
  brand: string;
}

export default function Footer({ brand }: FooterProps) {
  const brandConfig = BRANDING[brand] as BrandingConfig;

  if (!brandConfig) {
    console.error(`Brand configuration not found for: ${brand}`);
    return null;
  }

  return (
    <footer className={styles.footerContainer}>
      {/* Logo talentum*/}
      <div className={styles.logoContainer}>
        <Image
          className={styles.logoImage}
          src={brandConfig.footer_logo}
          alt="Logo del Proyecto"
          width={100}
          height={100}
        />
      </div>

      {/* Información de talentum */}
      <div className={styles.infoContainer}>
        <p className={styles.infoTitle}>{brandConfig.footer.title}</p>
        <address className={styles.infoText}>
          Dirección: {brandConfig.footer.address} <br />
          Código postal {brandConfig.footer.postalCode} <br />
        </address>
      </div>

      {/* Contacto de talentum */}
      <section className={styles.contactContainer}>
        <div className={styles.contactInfo}>
          <p className={styles.contactTitle}>Contáctanos</p>
          <a
            href={`mailto:${brandConfig.footer.email}`}
            className={styles.contactEmail}
          >
            {brandConfig.footer.email}
          </a>
        </div>

        <nav className={styles.LinksContainer}>
          <a
            href={brandConfig.footer.socialMedia.facebook}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.linkContact}
          >
            <FacebookOutlined className={styles.socialIcon} />
          </a>
          {brandConfig.footer.socialMedia.instagram && (
          	<a
            href={brandConfig.footer.socialMedia.instagram}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.linkContact}
          >
            <InstagramOutlined className={styles.socialIcon} />
          </a>
          )}
          {brandConfig.footer.socialMedia.linkedin && (
		  <a
            href={brandConfig.footer.socialMedia.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.linkContact}
          >
            <LinkedinOutlined className={styles.socialIcon} />
          </a>
          )}
          {brandConfig.footer.socialMedia.youtube && (
          <a
            href={brandConfig.footer.socialMedia.youtube}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.linkContact}
          >
            <YoutubeOutlined className={styles.socialIcon} />
          </a>
          )}
        </nav>
      </section>

      {/* Copyright */}
      <div className={styles.copyrightContainer}>
        <p className={styles.copyrightText}>
          {brandConfig.footer.copyright}
        </p>
      </div>
    </footer>
  );
}
